import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { CodehelpService } from 'virtue-form';
import { AuthService } from '../core/services/auth/auth.service';
import { ApiService } from '../core/services/shared/api.service';
import { CheckLoginSessionService } from '../core/services/shared/check-login-session.service';
import { GlobalVarService } from '../core/services/shared/global-var.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private globalvar: GlobalVarService,
    private codehelp: CodehelpService,
    private authService: AuthService,
    private apiservice: ApiService,
    private checkUserLogin: CheckLoginSessionService
  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const url: string = state.url;
    return this.isLogin(url);
  }

  isLogin(url: string): true | false | UrlTree {
    const redirectUrl = url.split('/');
    const UrlLength = redirectUrl.length;
    if (this.checkUserLogin.CheckUserSession() === true) {
      if (
        this.globalvar?.top5SubscriptionDashboardRequestData?.top5_request ==
        true
      ) {

        return true;
      } else {
        if (this.codehelp.getLoggedUserDetail()) {
          if (redirectUrl[UrlLength - 1] === 'login') {
            this.router.navigate(['/home/steps/0']);
            return true;
          } else if (redirectUrl[UrlLength - 1] === 'student' || redirectUrl[UrlLength - 1] === 'counselor') {
            this.router.navigate(['/home/steps/0']);
            return true;
          } else {
            return true;
          }
        } else {

          if (
            this.globalvar?.top5SubscriptionDashboardRequestData?.top5_request !== true && this.checkUserLogin.checkTop5RequestUserSession() === true
          ) {
            this.checkUserLogin.onLogout('');
          }
          else {

            return true;

          }
          //  this.router.navigate([this.globalvar.basepath + '/home/steps/0']);
        }
      }
    } else {
      if (redirectUrl[UrlLength - 1] === 'student' || redirectUrl[UrlLength - 1] === 'counselor') {
        // this.router.navigate(['/home/demouser']);
        return true;
      } else if (redirectUrl[UrlLength - 1] === 'login') {
        //  this.router.navigate(['/home/login']);
        return true;
      } else if (redirectUrl[UrlLength - 2] === 'steps' && (this.checkUserLogin.CheckUserSession() === false)) {
        this.checkUserLogin.onLogout('');
      }
      else {
        return true;
      }
    }
  }

}
